import type { NavDefaultOptionBasicConfig } from '~/components/PortalHeader';
import type { WishlistsState } from '~/composables/useWishlists/wishlists';

import OptionCollectionContent from '~/components/PortalHeader/Option/OptionCollectionContent.vue';

import IconMaterialSymbolsLightAccountCircle from '~icons/material-symbols-light/account-circle';
import IconMaterialSymbolsLightHotelClass from '~icons/material-symbols-light/hotel-class';
import IconMaterialSymbolsLightHotelClassOutline from '~icons/material-symbols-light/hotel-class-outline';

import { useWishlists } from './useWishlists/wishlists';

// Constants for better maintainability
const ICON_CLASSES = {
	ACCOUNT: '!size-5 text-beige scale-110',
	WISHLIST: '!size-6 text-beige scale-110'
} as const;

// Tipo estendido que inclui position para ordenação
type PositionedNavOption = NavDefaultOptionBasicConfig & {
	position: number;
};

// Constantes para posições (fácil de reorganizar)
const POSITIONS = {
	COLLECTION: 1,
	PROFILE: 2
} as const;

export function useHeaderNavProfile() {
	const wishlistsState = useState<WishlistsState>('wishlists');

	const userWishlists = computed(() => wishlistsState.value?.wishlists ?? []);
	const mainWishlistCount = computed(
		() =>
			userWishlists.value?.find((wishlist: any) => wishlist.mainWishlist)
				?.properties.length ?? 0
	);

	// Computed for wishlist icon selection - cleaner separation of concerns
	const wishlistIcon = computed(() => {
		return mainWishlistCount.value > 0
			? IconMaterialSymbolsLightHotelClass
			: IconMaterialSymbolsLightHotelClassOutline;
	});

	const profileOptions = computed<NavDefaultOptionBasicConfig[]>(() => {
		const baseOptions: PositionedNavOption[] = [
			{
				label: OptionCollectionContent,
				route: '/colecoes/minha-colecao',
				position: POSITIONS.COLLECTION,
				icon: {
					component: wishlistIcon.value,
					bindings: { class: ICON_CLASSES.WISHLIST }
				}
			},
			{
				label: 'Meus dados',
				route: '/perfil',
				position: POSITIONS.PROFILE,
				icon: {
					component: IconMaterialSymbolsLightAccountCircle,
					bindings: { class: ICON_CLASSES.ACCOUNT }
				}
			}
		];

		return baseOptions
			.sort((a, b) => a.position - b.position)
			.map(({ position, ...option }) => option);
	});

	return {
		profileOptions
	};
}
